/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_ManagerInputs */

const en_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Manager`)
};

const fr_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire KNP`)
};

const de_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Manager`)
};

const it_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile KNP`)
};

const ru_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер КНП`)
};

const es_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de KNP`)
};

const zh_cn2_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP经理`)
};

const ja_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNPマネージャー`)
};

const hi_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी प्रबंधक`)
};

const pt_pt2_knp_manager = /** @type {(inputs: Knp_ManagerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente do KNP`)
};

/**
* | output |
* | --- |
* | "KNP Manager" |
*
* @param {Knp_ManagerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager = /** @type {((inputs?: Knp_ManagerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_ManagerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager(inputs)
	if (locale === "de") return de_knp_manager(inputs)
	if (locale === "it") return it_knp_manager(inputs)
	if (locale === "ru") return ru_knp_manager(inputs)
	if (locale === "es") return es_knp_manager(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager(inputs)
	if (locale === "ja") return ja_knp_manager(inputs)
	if (locale === "hi") return hi_knp_manager(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager(inputs)
	return en_knp_manager(inputs)
});